// src/pages/InvesteeDashboard.js
import axios from 'axios';
import '../utils/axiosConfig'; // runs the 401/403 logout logic globally
import React, { useState, useEffect,useMemo } from 'react';
import { Link} from "react-router-dom";
import '../Style/Dashboard.css';
import "../Style/Responsive.css";
// import ChatBot from "./Chatbot";


import { 
  FaBook, 
  FaUser, 
  FaHandshake, 
  FaComments, 
  // FaSignOutAlt,
  // FaClipboardCheck,
  FaTrashAlt,
  FaCalendar,
  FaLock,
  FaUserCog,
  FaQuestionCircle } from 'react-icons/fa';

const InvesteeDashboard = () => {

  // ✅ NEW: auth token + headers 
 const token = useMemo(() => localStorage.getItem("token"), []);
 const headers = useMemo(() => ({ Authorization: `Token ${token}` }), [token]);
 
  const [avatar, setAvatar] = useState(null);
  // ✅ NEW: profile & match state
  const [profile, setProfile] = useState(null);
   const [matchesList, setMatchesList] = useState([]);
  const [selectedMatch, setSelectedMatch] = useState(null);
  const [manageOpen, setManageOpen] = useState(false);
  // Current user state, fetched from the backend.
  const [currentUser, setCurrentUser] = useState({ });
  const STATUS_STEPS = useMemo(
    () => ['pending', 'approved', 'rejected', 'funded'],
    []
  );

  // ✅ NEW: dummy fallback metrics
const DEFAULT_METRICS = {
capital_needed:    "$0.00",
funded_amount:     "$0.00",
annual_turnover:   "$0.00",
financial_position: "Profit",
team_capacity:  1,
current_stage:  "pending" // pending → approved → funded
};

  const currentStage  = selectedMatch?.status|| DEFAULT_METRICS.current_stage;
  const currentIndex  = STATUS_STEPS.findIndex(s => s === currentStage);




  // ✅ NEW: fetch profile info
  useEffect(() => {
    if (!token) return void(window.location.href = "/login");

    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/profile/`, { headers })
      .then(({ data }) => setProfile(data))
      .catch(() => {
        // fallback to /user/ if profile/ 404s
        axios
          .get(`${process.env.REACT_APP_API_BASE_URL}/user/`, { headers })
          .then(({ data }) => setProfile(data))
          .catch(() => setProfile({}));
      });
  },  [token,headers]); 


  // Fetch matches for this investee
  useEffect(() => {
    if (!token) return;
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/matches/`, { headers })
      .then(({ data }) => {
        if (Array.isArray(data)) {
          const two = data.slice(0, 2);
          setMatchesList(two);
          setSelectedMatch(two[0] || null);
        } else {
          setMatchesList([]);
          setSelectedMatch(null);
        }
      })
      .catch(() => {
        setMatchesList([]);
        setSelectedMatch(null);
      });
  }, [token, headers]);

  // Handle avatar change (simulate upload; in production, the avatar comes from backend).
  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setAvatar(URL.createObjectURL(file));
  };

 // merge real + default metrics
  const metrics = {
    capital_needed: profile?.capital_needed
      ? `$${Number(profile.capital_needed).toLocaleString()}`
      : '$0.00',
    funded_ammount: selectedMatch?.funded_ammount != null
      ? `$${Number(selectedMatch.funded_ammount).toLocaleString()}`
      : '$0.00',
    annual_turnover: profile?.annual_turnover
      ? `$${Number(profile.annual_turnover).toLocaleString()}`
      : '$0.00',
    financial_position: profile?.financial_position || 'Profit',
    team_capacity: profile?.team_capacity || 1,
    current_stage: selectedMatch?.status || 'pending'
  };

  
  // Fetch current user data (including avatar URL) from the backend.
    useEffect(() => {
      const token = localStorage.getItem('token');
      if (!token) {
        window.location.href = '/login';
        return;
      }
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/profile/`, {
        headers: { Authorization: `Token ${token}` },
      })
      .then(response => {
        setCurrentUser(prev => ({
          ...prev,
          business_name: response.data.business_name || response.data.business_name || "Investee",
          avatar: response.data.avatar || prev.avatar,
        }));
      })
      .catch(error => {
        console.error("Error fetching profile data:", error);
      });
    }, []);


 
   // === End New Event Calendar Functionality ===
 
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [isSidebarCollapsed] = useState(false);


  // Handle "Access TaxGPT" navigation.
  // const handleTaxGPTAccess = (e) => {
  //   e.preventDefault();
  //   if (window.confirm("Subscribe to access the Tax GPT")) {
  //     window.location.href = '/payment';
  //   }
  // };

  return (
    <div className="dashboard-container">
      {/* Side Navigation */}
      <aside className={`sidebar ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <button 
          className={`mobile-nav-toggle ${isMobileNavOpen ? 'active' : ''}`}
          onClick={() => setIsMobileNavOpen(!isMobileNavOpen)}
        >
          {isMobileNavOpen ? '✕' : '☰'}
        </button>
        <div id="avatar-upload">
        <label htmlFor="avatarInput">
      <img
      src={ avatar || currentUser.avatar || 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcToK4qEfbnd-RN82wdL2awn_PMviy_pelocqQ&s' }
      alt="Avatar"
      id="avatar-img"
    />
     </label>
          {/* Personalized Greeting */}
          <p className="greeting">
            Hi , Investee :<span id="greeting-name">{currentUser.business_name || "Investee"}</span> 
          </p>
          <input
            id="avatarInput"
            type="file"
            accept="image/jpeg, image/png"
            onChange={handleAvatarChange}
            style={{ display: 'none' }}
          />
        </div>
        <nav className={`nav-links ${isMobileNavOpen ? 'active' : ''}`}>
          <ul>
           
            <li>
              <Link to="/profile">
                <FaUser className="nav-icon" />
                Profile
              </Link>
            </li>
             <li>
              <Link to="/programs-loggedIn">
                <FaBook className="nav-icon" />
                Programs
              </Link>
            </li>
            <li>
              <Link to="/investee-match">
                <FaHandshake className="nav-icon" />
                Looking for Funding?
              </Link>
            </li>
            <li>
        <Link
          to="https://teams.microsoft.com/l/channel/19%3A1ff8550e81e046f2b352083b757a2520%40thread.tacv2/Trade%20Connect?groupId=8a4e4ff1-6630-402a-ad41-998ede82f756&tenantId=deff24bb-2089-4400-8c8e-f71e680378b2"
          target="_blank"
          rel="noopener noreferrer"
          className="tooltip"
        >
          <FaComments className="nav-icon" />
          Trade Connect
          <span className="tooltip-text">
          Join our vibrant community where investors, investees & stakeholders spark conversations around funding, startups & innovation—all in one place!
          </span>
        </Link>
      </li>

      {/* <li>
    <Link to="/self-assessment" className="tooltip">
      <FaClipboardCheck className="nav-icon" />
      Self Assessment
      <span className="tooltip-text">
        Self Assessment: a deep-dive into your business’s viability, 
        performance metrics & readiness to attract investment.
      </span>
    </Link>
  </li> */}

  <li>
  <Link to="/training-calendar"><FaCalendar /> Training Calendar</Link>
</li>
<li>
  <Link to="/events-calendar"><FaCalendar /> Events Calendar</Link>
</li>
<li>
      <Link to="/support" className="nav-link">
        <FaQuestionCircle className="nav-icon" />
        Support
      </Link>
  </li>
            <li className="manage-account …">
            <li
              className={`manage-account ${manageOpen ? 'open' : ''}`}
              onClick={() => setManageOpen(o => !o)}
            >
              <span className="manage-trigger">
                <FaUserCog className="nav-icon" /> Manage Account
              </span>
            
              {/* modal overlay */}
              {manageOpen && (
                <div
                  className="manage-modal-overlay"
                  onClick={() => setManageOpen(false)}
                >
                  <div
                    className="manage-modal"
                    onClick={e => e.stopPropagation()}
                  >
                    <button
                      className="close-btn"
                      onClick={() => setManageOpen(false)}
                    >
                      ×
                    </button>
                    <h3>Manage Account</h3>
                    <ul>
                      <li>
                        <Link to="/change-password">
                          <FaLock className="nav-icon" /> Change Password
                        </Link>
                      </li>
                      <li>
                        <Link to="/delete-account">
                          <FaTrashAlt className="nav-icon" /> Delete Account
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </li>
            </li>
            
          </ul>
        </nav>
      </aside>

    {/* Main Content */}
      <main className="main-content">
      <div class="greeting-container"> 
        <h2>
        Welcome ,
        </h2>
        <h2 id="greeting-name">
        {currentUser.business_name || "Investee"} !
        </h2>
        
        </div>
       
{/* dashboard message */}
<div className="dev-notice">
  <strong></strong> 
  Track your metrics, and funding stages.
</div>


  {/* Metrics Grid */}
        <div className="metrics-grid">
          <div className="metric-item">
            <span className="metric-label">Ticket Size</span>
            <span className="metric-value">{metrics.capital_needed}</span>
          </div>
          <div className="metric-item">
            <span className="metric-label">Funding Received</span>
            <span className="metric-value">{metrics.funded_ammount}</span>
          </div>
          <div className="metric-item">
            <span className="metric-label">Annual Turnover</span>
            <span className="metric-value">{metrics.annual_turnover}</span>
          </div>
          <div className="metric-item">
            <span className="metric-label">Financial Position</span>
            <span className="metric-value">{metrics.financial_position}</span>
          </div>
          <div className="metric-item">
            <span className="metric-label">Team Capacity</span>
            <span className="metric-value">{metrics.team_capacity}</span>
          </div>
        </div>

  {/* Funding Stage Tracker */}
        <div className="stage-section">
          <p className="stage-subheader">
            Track your journey from registration through funding
          </p>
          <div className="stage-tracker">
           {STATUS_STEPS.map((step, i) => {
  const isCompleted = i < currentIndex;
  const isActive    = i === currentIndex;
  return (
  <div
  key={step}
  className={
    `stage-step ${step} ` +
    (isCompleted ? 'completed ' : '') +
    (isActive    ? 'active'     : 'upcoming')
  }>

      <div className="step-circle">{i + 1}</div>
      <span className="step-label">
        {step.charAt(0).toUpperCase() + step.slice(1)}
      </span>
    </div>
  );
})}
</div>
</div>
 {/* Matched Investors Table */}
<div className="matched-investors-table">
  <h3>Your Matched Investors</h3>
  <table>
    <thead>
      <tr>
        <th>Investor Name</th>
        <th>Sector</th>
        <th>Match Score</th>
        <th>Funded</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      {matchesList.length === 0 ? (
        <tr>
          <td colSpan="4" className="no-matches-message">
            You currently have no matches. Please check back later.
          </td>
        </tr>
      ) : (
        matchesList.map(m => (
          <tr key={m.id}>
            <td>{m.investor.investor_name}</td>
            <td>
              {Array.isArray(m.investor.sectors_of_interest)
                ? m.investor.sectors_of_interest.join(', ')
                : '-'}
            </td> 
            <td>{m.match_score}%</td>
            <td>
              {m.funded_ammount > 0
                ? `$${Number(m.funded_ammount).toLocaleString()}`
                : '-'}
            </td>
            <td>
              <button onClick={() => setSelectedMatch(m)}>
                View Status
              </button>
            </td>
          </tr>
        ))
      )}
    </tbody>
  </table>
</div>

</main>
      
      {/* <ChatBot /> */}
</div>
  );
};

export default InvesteeDashboard;
